import HTTP from "./axios";
const resource = "/fmx";

export default {
  /**
   * Get configuration data from server
   * @returns {*}
   */
  initialize() {
    return HTTP.get(`${resource}/initialize`);
  },

  /**
   * Get directories for the tree (upper level)
   * @param disk
   * @param path
   * @returns {*}
   */
  tree(disk, path) {
    return HTTP.get(`${resource}/tree`, { params: { disk, path } });
  },

  /**
   * Select disk
   * @param disk
   * @returns {*}
   */
  selectDisk(disk) {
    return HTTP.get(`${resource}/select-disk`, { params: { disk } });
  },

  /**
   * Get content (files and folders)
   * @param disk
   * @param path
   * @returns {*}
   */
  content(disk, path) {
    return HTTP.get(`${resource}/content`, { params: { disk, path } });
  },

  /**
   * Item properties
   */
  /* properties(disk, path) {
    return HTTP.get(`${resource}/properties`, { params: { disk, path } });
  }, */

  /**
   * URL
   * @param disk
   * @param path
   * @returns {*}
   */
  url(disk, path) {
    return HTTP.get(`${resource}/url`, { params: { disk, path } });
  },

  /**
   * Get file to editing or showing
   * @param disk
   * @param path
   * @returns {*}
   */
  getFile(disk, path) {
    return HTTP.get(`${resource}/download`, { params: { disk, path } });
  },

  /**
   * Get file - ArrayBuffer
   * @param disk
   * @param path
   * @returns {*}
   */
  getFileArrayBuffer(disk, path) {
    return HTTP.get(`${resource}/download`, {
      responseType: "arraybuffer",
      params: { disk, path }
    });
  },

  /**
   * Image thumbnail
   * @param disk
   * @param path
   * @returns {*}
   */
  thumbnail(disk, path) {
    return HTTP.get(`${resource}/thumbnails`, {
      responseType: "arraybuffer",
      params: { disk, path }
    });
  },

  /**
   * Image preview
   * @param disk
   * @param path
   * @return {*}
   */
  preview(disk, path) {
    return HTTP.get(`${resource}/preview`, {
      responseType: "arraybuffer",
      params: { disk, path }
    });
  },

  /**
   * Download file
   * @param disk
   * @param path
   * @return {*}
   */
  download(disk, path) {
    return HTTP.get(`${resource}/download`, {
      responseType: "arraybuffer",
      params: { disk, path }
    });
  }
};
